<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("configurar-recibos") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a>{{ $t("despesas") }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'des-configurar-recibos-list',
                                            })
                                        "
                                        >{{ $t("configurar-recibos") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        this.$route.params.id
                                            ? this.$route.params.id
                                            : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({ name: 'des-configurar-recibos-list' })
                            "
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="
                                (!isUpdate && permissao.create) ||
                                (isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="saveRecibo"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div>
                    <div class="columns" style="height: 66px !important">
                        <div class="column is-8">
                            <v-input
                                ref="tituloInput"
                                v-model="recibo.titulo"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                :title="'titulo-configuracao-recibo'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!recibo.titulo"
                                uppercase
                                :required="true"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                ref="reciboInput"
                                title="recibo"
                                :options="reciboSelect"
                                :mlLabels="true"
                                @input="reciboChanged"
                                v-model="reciboSelected"
                                :disabled="recibo.idconfjasper != null"
                            />
                        </div>
                    </div>
                    <div class="box">
                        <div class="columns">
                            <div class="column is-8">
                                <v-textarea
                                    ref="textoInput"
                                    id="texto-recibo"
                                    tooltipLabel="max-rows-confjasper"
                                    v-model="recibo.texto"
                                    :title="'descricao-rodape-recibo'"
                                    :maxlength="1800"
                                    :msg="'msg-campo-obrigatorio'"
                                    :invalid="
                                        recibo.texto == '' ||
                                        recibo.texto == null
                                    "
                                    placeholder="placeholder-preencha"
                                    :rows="19"
                                    :maxRows="19"
                                    :displayCounter="true"
                                    :disableTransform="true"
                                    :required="true"
                                />
                            </div>
                            <div class="column is-4">
                                <label>{{
                                    $t("variaveis-disponiveis")
                                }}</label>
                                <div class="select-div">
                                    <ul class="select-ul select-ul-custom">
                                        <li
                                            v-for="(v, index) in variaveis"
                                            :key="index"
                                            @click="append(v)"
                                        >
                                            {{ v }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-8">
                            <label
                                class="label-medium"
                                v-if="
                                    file === null &&
                                    (recibo.namejasper === null ||
                                        recibo.namejasper == undefined)
                                "
                            >
                                <i class="fas fa-list-ul"></i>
                                {{ $t("layout-recibo-jasper") }}
                            </label>

                            <b-field
                                class="file is-primary"
                                :class="{
                                    'has-name':
                                        file != null ||
                                        recibo.namejasper != null,
                                }"
                            >
                                <b-upload
                                    v-model="file"
                                    class="file-label"
                                    accept=".jasper"
                                >
                                    <span class="file-cta">
                                        <b-icon
                                            class="file-icon"
                                            icon="upload"
                                        ></b-icon>
                                        <div
                                            class="file-label"
                                            v-if="
                                                file != null ||
                                                recibo.namejasper != null
                                            "
                                        >
                                            {{
                                                $t(
                                                    "selecionar-outro-layout"
                                                )
                                            }}
                                        </div>
                                        <div class="file-label" v-else>
                                            {{
                                                $t("trocar-layout-padrao")
                                            }}
                                        </div>
                                    </span>
                                    <span
                                        class="file-name"
                                        v-if="file != null"
                                        :title="file.name"
                                    >
                                        {{ file.name }}
                                    </span>
                                    <span
                                        class="file-name"
                                        v-else-if="recibo.namejasper != null"
                                        :title="recibo.namejasper"
                                    >
                                        {{ recibo.namejasper }}
                                    </span>
                                </b-upload>
                                <b-button
                                    v-if="
                                        $route.params.id &&
                                        recibo.namejasper != null &&
                                        !file
                                    "
                                    class="download-jasper"
                                    @click="downloadJasper()"
                                    v-tippy 
                                    :title="$t('baixar-layout-recibo-jasper')"
                                >
                                    <i class="fas fa-download"/>
                                </b-button>
                            </b-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConfigurarRecibosService from "@/services/despesas/ConfigurarRecibosService";
import ConfigurarRecibosValidation from "@/services/validations/despesas/ConfigurarRecibosValidation.js";
import Message from "@/models/Message";

export default {
    data() {
        return {
            variaveis: [],
            service: new ConfigurarRecibosService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: null,
            recibo: {
                idconfjasper: null,
                titulo: null,
                texto: null,
                pathjasper: null,
                namejasper: null,
                identificador: null,
            },
            file: null,
            urlDowloadJasper: "",
            isUpdate: false,
            reciboSelect: [
                { id: 'despesa_acerto', label: "acertos" },
                { id: 'des_acerto_despesa', label: "prestacao-contas" },
            ],
            reciboSelected: { id: 'despesa_acerto', label: "acertos" },
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
        }

        this.permissao = this.hasPermissionAccess(
            "despesas",
            "cadastros",
            "des-configurar-recibos"
        );
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "configurar-recibos" },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            }
            this.validation = new ConfigurarRecibosValidation(this.msgs);
            this.findEnums();
        }
    },
    watch: {
        file() {
            if (this.file != null) {
                if (this.file != this.recibo.namejasper) {
                    this.recibo.namejasper = this.file.name;
                    this.fileToBase64(this.file).then((result) => {
                        this.recibo.pathjasper = result;
                    });
                }
            }
        },
    },
    methods: {
        reciboChanged(val) {
            console.log(val);
        },
        // Convert file to base64 string
        fileToBase64(file) {
            return new Promise((resolve) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = () => {
                    let encoded = reader.result
                        .toString()
                        .replace(/^data:(.*,)?/, "");
                    if (encoded.length % 4 > 0) {
                        encoded += "=".repeat(4 - (encoded.length % 4));
                    }
                    resolve(encoded);
                };
                reader.onerror = (error) => reject(error);
            });
        },
        downloadJasper() {
            this.service
                .downloadJasper(this.recibo.idconfjasper)
                .then((r) => {
                    let filename = `recibo-${this.recibo.idconfjasper}.jasper`;
                    let blob = new Blob([r], { type: "application/file" });
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute("download", filename);
                    //link.download = fileName;
                    link.click();
                    setTimeout(function () {
                        window.URL.revokeObjectURL(blob);
                    }, 100);
                })
                .catch((e) => {
                    console.error("Ocorreu algum erro: " + e);
                })
                .finally(() => {
                    // console.log('Download do jasper finalizado');
                });
        },
        findEnums() {
            this.service
                .findEnums()
                .then((value) => {
                    this.variaveis = value.content;
                    Object.entries(this.variaveis).forEach(
                        ([key, variavel]) => {
                            this.variaveis[key] = "[" + variavel + "]";
                        }
                    );
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                });
        },

        append(v) {
            if (this.recibo.texto == null) this.recibo.texto = "";
            let last = this.recibo.texto.charAt(this.recibo.texto.length - 1);
            if (this.recibo.texto == "") v = v + " ";
            if (last != " " && this.recibo.texto != "") v = " " + v + " ";
            else if (last == " ") v = v + " ";

            this.recibo.texto = this.recibo.texto.concat(v);
            document.getElementById("texto-recibo").focus();
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.recibo.idconfjasper = value.content.idconfjasper;
                    this.recibo.titulo = value.content.titulo;
                    this.recibo.texto = value.content.texto;
                    this.recibo.namejasper = value.content.namejasper;
                    this.recibo.identificador = value.content.identificador;
                    this.reciboSelected = this.reciboSelect.find(f => {
                        return f.id == value.content.identificador
                    });
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        saveRecibo() {
            let reciboTemp = this.mapToSaveJasper(this.recibo);
            this.isLoading = true;

            if (this.validation.validate(this.recibo, this.$refs)) {
                this.isSaving = true;

                this.recibo.identificador = this.reciboSelected.id;

                this.service
                    .save(reciboTemp)
                    .then((value) => {
                        if (value.content) {
                            let msg = "msg-save-configuracao-recibo";
                            if (this.recibo.idconfjasper != null)
                                msg = "msg-edit-configuracao-recibo";
                            this.msgs.push(new Message("success", msg, true));
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                            this.isSaving = false;
                        }
                        this.redirectToList();
                    })
                    .catch((e) => {
                        console.error(e);
                        this.msgs.push(
                            new Message("error", "msg-erro-load", true)
                        );
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.isLoading = false;
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: "des-configurar-recibos-list",
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }
    .select-div {
        height: 423px;
        overflow-y: scroll;
        border: solid 1px #dbdbdb;
        background-color: #fefefe;
        border-radius: 4px;
        box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    }
    .select-ul-custom > li {
        padding: 4px 10px;
        border-bottom: solid 1px #dbdbdb;
    }
    .select-ul-custom > li:last-child {
        border-bottom: none;
    }
    .select-ul-custom > li:hover {
        cursor: pointer;
        background-color: #ece7e7;
    }
    .select {
        min-width: 350px;
    }

    .download-jasper {
        margin-left: 1rem;
        background-color: $primary-color;
        color: $sovis-white;
    }
}

.is-primary:not(input[type="checkbox"] + span.check) {
    background-color: transparent !important;
}
</style>
